/**
 * Dynamic theme loader for PrimeReact
 * This file handles loading themes without Tailwind processing
 */

const AVAILABLE_THEMES = {
  'bootstrap4-light-blue': () => import('primereact/resources/themes/bootstrap4-light-blue/theme.css'),
  'bootstrap4-dark-blue': () => import('primereact/resources/themes/bootstrap4-dark-blue/theme.css'),
  'lara-light-blue': () => import('primereact/resources/themes/lara-light-blue/theme.css'),
  'lara-dark-blue': () => import('primereact/resources/themes/lara-dark-blue/theme.css'),
  'lara-light-indigo': () => import('primereact/resources/themes/lara-light-indigo/theme.css'),
  'lara-dark-indigo': () => import('primereact/resources/themes/lara-dark-indigo/theme.css'),
};

let currentTheme = null;

export async function loadTheme(themeName) {
  if (AVAILABLE_THEMES[themeName]) {
    try {
      await AVAILABLE_THEMES[themeName]();
      currentTheme = themeName;
      return true;
    } catch (error) {
      console.error(`Failed to load theme "${themeName}":`, error);
      return false;
    }
  }
  console.warn(`Theme "${themeName}" not found in available themes`);
  return false;
}

export function getAvailableThemes() {
  return Object.keys(AVAILABLE_THEMES);
}

export function getCurrentTheme() {
  return currentTheme;
}
